import { MenuItem } from './menu.types'
 
export const menuMedico = (navigate: Function): MenuItem[] => {
 
	return [
		{
			label: 'Calendario',
			action: () => navigate('/med/calendario'),
		},
		{
			label: 'Turnos',
			action: () => navigate('/med/turnos'),
		},
		{
			label: 'Perfil',
			subItems: [
				{
					label: 'Mi Perfil',
					action: () => navigate('/med/perfil')
				},
				{
					label: 'Cambiar Contraseña',
					action: () => navigate('/med/change-pass')
				},
				{
					label: 'Pedir Ayuda',
					action: () => navigate('/med/ayuda')
				},
				{
					label: 'Salir',
					action: () => navigate('/med/login')
				}
			]
		}
	]
}
